<script setup lang="ts">
import WorkspaceGroupCard from '@/components/settingsMenu/sections/groups/WorkspaceGroupCard.vue';
</script>

<template>
    <div class="title flex flex-col gap-6">
        <div class="flex flex-col gap-2">
            <h2 class="text-xl font-semibold">Groups</h2>
            <p class="text-sm text-muted-foreground">
                Manage user groups and import Azure AD groups.
            </p>
        </div>

        <WorkspaceGroupCard />
    </div>
</template>
